// Pratik e-posta denetimi: RFC'nin tamamı değil, gerçek hayattaki adreslerin güvenli alt kümesi.
const EMAIL_PATTERN = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/;
/** Kırpar ve küçük harfe çevirir (Türkçe yerel ayarı olmadan: "I" → "i"). */
export function normalizeEmail(value) {
    return value.trim().toLocaleLowerCase("en-US");
}
export function isValidEmail(value) {
    const email = normalizeEmail(value);
    if (email.length > 254)
        return false;
    const [local = ""] = email.split("@");
    if (local.length > 64 || local.startsWith(".") || local.endsWith(".") || local.includes(".."))
        return false;
    return EMAIL_PATTERN.test(email);
}
/** Log için maskeleme (KVKK): "a***@ornek.com" */
export function maskEmail(value) {
    const email = normalizeEmail(value);
    const at = email.lastIndexOf("@");
    if (at <= 0)
        return "***";
    return `${email[0]}***${email.slice(at)}`;
}
//# sourceMappingURL=email.js.map